import type { Sticker } from '../types';

export const tropicalFruits: Sticker[] = [
  {
    id: 25001,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/001-papaya.png',
    name: 'Papaja',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25002,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/002-watermelon.png',
    name: 'Arbuz',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25003,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/003-soursop.png',
    name: 'Flaszowiec',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25004,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/004-avocado.png',
    name: 'Awokado',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25005,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/005-pomegranate.png',
    name: 'Granat',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25006,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/006-mangosteen.png',
    name: 'Mangostan',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25007,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/007-guava.png',
    name: 'Guawa',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25008,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/008-kiwi.png',
    name: 'Kiwi',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25009,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/009-mamoncillo.png',
    name: 'Mamoncillo',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25010,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/010-banana.png',
    name: 'Banan',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25011,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/011-watermelon.png',
    name: 'Kawałek Arbuza',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25012,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/012-orange.png',
    name: 'Pomarańcza',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25013,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/013-pitaya.png',
    name: 'Pitaja',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25014,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/014-feijoa.png',
    name: 'Fejhoa',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25015,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/015-mango.png',
    name: 'Mango',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25016,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/016-coconut.png',
    name: 'Kokos',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25017,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/017-pineapple.png',
    name: 'Ananas',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25018,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/018-tropical fruits.png',
    name: 'Owoce Tropikalne',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25019,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/019-lemon.png',
    name: 'Cytryna',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 25020,
    url: 'https://stickers.nauczniaczek.pl/colections/14874366-tropical-fruits/png/020-fig.png',
    name: 'Figa',
    category: 'tropical-fruits',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];